import { render } from "./therapyFilter.vue?vue&type=template&id=39950ed2"
import script from "./therapyFilter.vue?vue&type=script&lang=js"
export * from "./therapyFilter.vue?vue&type=script&lang=js"

import "./therapyFilter.vue?vue&type=style&index=0&id=39950ed2&lang=css"
import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__